import { Slider, SliderSingleProps } from 'antd';
import React, { useMemo } from 'react';

import { BRAND_PRIMARY } from '../../../foundation/config/colors';

type InterpretationHeatmapSliderProps = {
  postProbability?: string;
};

const sliderMarks: SliderSingleProps['marks'] = {
  0: {
    label: 'benign',
  },
  0.5: {
    label: <span>uncertain significance</span>,
  },
  1: 'pathogenic',
};

const InterpretationHeatmapSlider = ({
  postProbability,
}: InterpretationHeatmapSliderProps) => {
  const sliderValue = useMemo(() => {
    if (!postProbability) {
      return undefined;
    }

    const parsedValue = parseFloat(postProbability);
    return Number.isNaN(parsedValue) ? undefined : parsedValue;
  }, [postProbability]);

  const sliderValueLabel = useMemo(() => {
    if (sliderValue === undefined) {
      return '';
    }
    return `${(sliderValue * 100).toFixed(1)}%`;
  }, [sliderValue]);

  return (
    <div className="l-interpretation__heatmap-slider-wrapper">
      <div className="l-interpretation__heatmap-slider-labels">
        <span>benign</span>
        <span>uncertain significance</span>
        <span>pathogenic</span>
      </div>
      <div
        className="l-interpretation__heatmap-slider-arrow"
        aria-hidden="true"
      >
        <span className="l-interpretation__heatmap-slider-arrow-head l-interpretation__heatmap-slider-arrow-head--left" />
        <span className="l-interpretation__heatmap-slider-arrow-head l-interpretation__heatmap-slider-arrow-head--right" />
      </div>
      <div className="l-interpretation__heatmap-slider-track">
        <Slider
          tooltip={{
            open: false,
          }}
          marks={sliderMarks}
          className="l-interpretation__heatmap-slider"
          styles={{
            track: {
              background: 'transparent',
            },
            rail: {
              background:
                'linear-gradient(90deg, #006632 5%, #80B119 14%, #FFFC00 42%, #F4B812 78%, #E91B24 94%, #E91B24 100%)',
              height: 7,
            },
            handle: {
              background: BRAND_PRIMARY,
              color: BRAND_PRIMARY,
              backgroundColor: BRAND_PRIMARY,
            },
          }}
          value={sliderValue}
          max={1}
          min={0}
          step={0.01}
        />
        {sliderValue !== undefined && (
          <div
            className="l-interpretation__heatmap-slider-value"
            style={{ left: `${sliderValue * 100}%` }}
          >
            {sliderValueLabel}
          </div>
        )}
      </div>
    </div>
  );
};

export default InterpretationHeatmapSlider;
